// extracted by mini-css-extract-plugin
export default {"btn":"SetAsPaidBtn_btn__53Ytx","on":"SetAsPaidBtn_on__yZIcv","off":"SetAsPaidBtn_off__o5wiW"};